import React, { useRef, useState } from "react";
import "./css/partners.css";

import partner_iso from "./assets/Partner1.png";
import partner_EU from "./assets/Partner2.png";
import partner_UNIDO from "./assets/Partner3.png";
import partner_UNDP from "./assets/Partner4.png";
import partner_MW_government from "./assets/Partner5.png";
import partner_World_Bank from "./assets/Partner6.png";
import partner_WHO from "./assets/Partner7.png";
import partner_WFP from "./assets/Partner8.png";
import partner_IEC from "./assets/Partner9.png";
import partner_AFSEC from "./assets/Partner10.png";
import partner_AFRIMETS from "./assets/Partner11.png";
import partner_OIML from "./assets/Partner12.png";
import partner_BIPM from "./assets/Partner13.png";

const PartnersSlider = ({ speed = 30 }) => {
  const partners = [
    { img: partner_iso, link: "https://www.iso.org/home.html" },
    { img: partner_EU, link: "https://european-union.europa.eu/index_en" },
    { img: partner_UNIDO, link: "https://www.unido.org/" },
    { img: partner_UNDP, link: "https://www.undp.org/" },
    { img: partner_MW_government, link: "https://www.malawi.gov.mw/" },
    { img: partner_World_Bank, link: "https://www.worldbank.org/ext/en/home" },
    { img: partner_WHO, link: "https://www.who.int/" },
    { img: partner_WFP, link: "https://www.wfp.org/" },
    { img: partner_IEC, link: "https://www.iec.ch/homepage" },
    { img: partner_AFSEC, link: "https://afsec-africa.org/" },
    { img: partner_AFRIMETS, link: "http://www.afrimets.org/Pages/home.aspx" },
    { img: partner_OIML, link: "https://www.oiml.org/en/front-page" },
    { img: partner_BIPM, link: "https://www.bipm.org/en/" },
  ];

  const trackRef = useRef(null);
  const [key, setKey] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const handleRestart = () => setKey((prev) => prev + 1);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e, link) => {
    touchEndX.current = e.changedTouches[0].clientX;
    const distance = Math.abs(touchEndX.current - touchStartX.current);

    if (distance < 10) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="partners-slider">
      <h2>
        <span className="line"></span>
        SOME OF OUR PARTNERS
        <span className="line"></span>
      </h2>

      <div className="slider2" onClick={handleRestart}>
        <div className="fade-left"></div>
        <div className="fade-right"></div>

        <div
          key={key}
          className="slider-track"
          ref={trackRef}
          style={{ "--logo-count": partners.length, "--speed": `${speed}s` }}
        >
          {partners.map((partner, index) => (
            <div
              className="partner-logo"
              key={index}
              onTouchStart={handleTouchStart}
              onTouchEnd={(e) => handleTouchEnd(e, partner.link)}
            >
              <a
                href={partner.link}
                target="_blank"
                rel="noopener noreferrer"
                className="desktop-link"
              >
                <img src={partner.img} alt={`Partner ${index}`} />
              </a>
            </div>
          ))}

          {partners.map((partner, index) => (
            <div
              className="partner-logo"
              key={`dup-${index}`}
              onTouchStart={handleTouchStart}
              onTouchEnd={(e) => handleTouchEnd(e, partner.link)}
            >
              <a
                href={partner.link}
                target="_blank"
                rel="noopener noreferrer"
                className="desktop-link"
              >
                <img src={partner.img} alt={`Partner Duplicate ${index}`} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnersSlider;
